// AppConstant.js
export const MSG_DURATION = 5;

// Assessment Constant

export const MIN_RECORDING_DURATION = 30;
export const DEFAULT_ASSESSMENT_TYPE = "initial";
export const DEFAULT_CUSTOMER_KEY = "testkey";
export const PRONOUNCIATION_PRO_CUSTOMER_ID = 1;
// Threshold for what is considered "silence". Any audio signal with an absolute amplitude
// below this value is considered silent. In this case, 0.02 is a small value,
// meaning very low audio levels are treated as silence.
export const SILENCE_THRESHOLD = 0.02;
// Maximum duration (in seconds) of initial silence that we are willing to allow in the audio.
// If the silence exceeds this value, we assume the audio is "silent" at the start. In this case,
// it is set to 7 seconds.
export const MAX_SILENCE_DURATION = 7;

export const SILENCE_THRESHOLD_DB = -20; // Silence threshold in dB
export const NOISE_THRESHOLD_DB = -2; // Noise threshold in dB
export const CHUNK_DURATION = 7; // Chunk duration in seconds

// Payment Constants
export const ASSESSMENT_REPORT = {
  AMOUNT: "199",
  CURRENCY: "INR",
  MODAL_TARGET: "_modal",
  ENVIRONMENT: {
    SANDBOX: "sandbox",
    PRODUCTION: "production",
  },
};

// UI Messages
export const UI_MESSAGES = {
  ERRORS: {
    SDK_NOT_INITIALIZED: "Cashfree SDK not initialized",
    INVALID_ORDER: "Invalid order response from server",
    ORDER_ID_NOT_FOUND: "Order ID not found",
    PAYMENT_VERIFICATION:
      "Unable to verify payment status. Please contact support.",
    PAYMENT_INCOMPLETE: "Your payment was not completed. Please try again.",
    PAYMENT_FAILED: "Unable to process payment. Please try again.",
    PAYMENT_CANCELLED: "The payment window was closed or there was an error",
    SOMETHING_WRONG: "Something went wrong",
    SILENCE_DETECTED: "Silence Detected in Audio",
    SILENCE_RETRY:
      "The audio contains a long pause at the beginning or end. Please try again.",
  },
  SUCCESS: {
    PAYMENT_COMPLETED: "Payment Successful",
    REPORT_UNLOCKED: "Thank you for your purchase. You may now create a new Assessment Report.",
  },
  TITLES: {
    PAYMENT_CANCELLED: "Payment Cancelled",
    PAYMENT_FAILED: "Payment Failed",
    PAYMENT_VERIFICATION_FAILED: "Payment Verification Failed",
    PAYMENT_INCOMPLETE: "Payment Incomplete",
    ERROR: "Error",
  },
};

// Assessment Messages
export const ASSESSMENT_MESSAGES = {
  ERRORS: {
    NO_SCRIPT: "No script found",
    SCRIPT_REQUIRED: "Please add the script before recording",
    MIC_PERMISSION_DENIED: "Microphone Permission Denied",
    MIC_PERMISSION_CHECK: "Please check your microphone permission in browser",
    SMALL_RECORDING: "Recorded audio is small. ",
    RECORD_FULL_SCRIPT: "Please record the whole script.",
    GENERATE_ERROR: "Error in Generating Assessment Report.",
    TRY_AGAIN: "Please try again after some time.",
    LOAD_ERROR: "Failed to load assessment data. Please try again.",
    CUSTOMER_MISSING: "Customer information is missing",
    STORE_ERROR: "Failed to store customer information",
  },
  INFO: {
    ASSESSMENT_FOUND: "assessment found",
    GENERATING_REPORT: "Please wait - Generating Assessment Report",
    RECORD_INSTRUCTIONS: "Record yourself reading this script with microphone.",
    CLICK_INSTRUCTIONS:
      "Click the microphone button to start recording. Once you have finished the script, click the Stop button.",
    RECORDING: "Recording..",
  },
};

// Thank You Page Messages
export const THANK_YOU_MESSAGES = {
  TITLE_PREFIX: "Thank You for Your Assessment, ",
  VIEW_REPORT_BUTTON:
    "You can view the report with the Download Report button.",
  EMAIL_NOTIFICATION:
    "We will send your assessment report to your registered email ID.",
  ASSESSMENT_ISSUE:
    "There was an issue with the assessment. Please complete the assessment again.",
  BUTTON_LABELS: {
    BACK: "Back",
    DOWNLOAD_REPORT: "Download Report",
  },
};

// Form Validation Messages
export const FORM_MESSAGES = {
  REQUIRED: {
    AUDIO: "Please record the passage in your voice.",
    SCRIPT: "Please input your audio script!",
  },
  FILE_TYPES: {
    AUDIO: "Supported file types: .mp3,.wav",
  },
  DURATION: {
    PREFIX: "Maximum file duration allowed:",
    MINUTES: " minutes",
    SECONDS: " seconds",
  },
};

// Audio Processing Messages
export const AUDIO_MESSAGES = {
  ERRORS: {
    FILE_DURATION: "File duration exceeds the limit",
    UPGRADE_MESSAGE:
      "Please upgrade your plan to upload & access longer files.",
    AUDIO_ERROR: "Error in the audio file.",
    PLEASE_TRY: "Please try again.",
  },
};

// Email and Support Constants
export const SUPPORT = {
  EMAIL: "support@pronunciationpro.com",
};

export const SCRIPT_MESSAGES = {
  VALIDATION: {
    REQUIRED: "Please provide the script",
    PLACEHOLDER: "You can either write in this text box or paste the script.",
  },
};

export const UPLOAD_MESSAGES = {
  DRAG_DROP: "Click or drag audio file to this area to upload",
  FILE_SELECT: "Please select audio file!",
  DURATION_EXCEEDED: "File size duration exceed",
};

export const RECORDING_MESSAGES = {
  TITLE: "Record audio with microphone",
  BUTTONS: {
    START: "Start Recording",
    STOP: "Stop Recording",
    RESET: "Reset",
    GET_REPORT: "Get Report",
  },
};

export const SAMPLE_MESSAGES = {
  LINK_TEXT: "Check sample Assessment report here",
};
